/**
 * MXP365 Module ID to path mappings
 */
const MXP_MODULE_PATHS: Record<string, string> = {
  'mxp365-shorex': '/activities/tours/shore-excursions',
  'mxp365-itinerary': '/activities/tours/itinerary',
  'mxp365-port-info': '/itinerary',
  'mxp365-my-calendar': '/my-calendar',
  'mxp365-board-activities': '/activities/dailyevents/board-activities',
  'mxp365-spa': '/activities/spa/spa',
  'mxp365-fitness': '/activities/spa/fitness',
  'mxp365-hair-dresser': '/activities/spa/hair-dresser',
  'mxp365-makeup': '/activities/spa/permanent-makeup-parent',
  'mxp365-restaurants': '/restaurants',
  'mxp365-packages': '/packages',
  'mxp365-venues': '/venues',
  'mxp365-deck-plan': '/deck-plan',
  'mxp365-opening-hours': '/opening-hours',
  'mxp365-announcements': '/announcements',
  'mxp365-weather': '/weather',
  'mxp365-favorites': '/favorites',
  'mxp365-chat': '/chat',
  'mxp365-messages': '/messages',
};

const DEFAULT_MXP_PATH = '/activities/tours/shore-excursions';

/**
 * Convert a module ID or path to a valid MXP365 path
 * @param pathOrModuleId - Can be a module ID (e.g., 'mxp365-shorex') or a direct path
 * @returns A valid MXP365 path, defaults to shore excursions if input is undefined/empty
 */
export const toValidMxpPath = (
  pathOrModuleId: string | undefined | null,
): string => {
  // If undefined, null, or empty, return the default path
  if (!pathOrModuleId) {
    return DEFAULT_MXP_PATH;
  }

  // If it's a known module ID, return the mapped path
  if (MXP_MODULE_PATHS[pathOrModuleId]) {
    return MXP_MODULE_PATHS[pathOrModuleId];
  }

  // Otherwise, return the path as-is
  return pathOrModuleId;
};
